import ButtonIcon from "./baseSVG/ButtonIcon";

const DeleteIcon = ({ className }) => {
  return (
    <ButtonIcon className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7 6V3C7 2.73478 7.10536 2.48043 7.29289 2.29289C7.48043 2.10536 7.73478 2 8 2H16C16.2652 2 16.5196 2.10536 16.7071 2.29289C16.8946 2.48043 17 2.73478 17 3V6H22V8H20V21C20 21.2652 19.8946 21.5196 19.7071 21.7071C19.5196 21.8946 19.2652 22 19 22H5C4.73478 22 4.48043 21.8946 4.29289 21.7071C4.10536 21.5196 4 21.2652 4 21V8H2V6H7ZM13.414 14L15.182 12.232L13.768 10.818L12 12.586L10.232 10.818L8.818 12.232L10.586 14L8.818 15.768L10.232 17.182L12 15.414L13.768 17.182L15.182 15.768L13.414 14ZM9 4V6H15V4H9Z"
        fill="black"
      />
    </ButtonIcon>
  );
};

export default DeleteIcon;
